import { render, staticRenderFns } from "./Covid_check.vue?vue&type=template&id=706773f0&scoped=true"
import script from "./Covid_check.vue?vue&type=script&lang=js"
export * from "./Covid_check.vue?vue&type=script&lang=js"
import style0 from "./Covid_check.vue?vue&type=style&index=0&id=706773f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706773f0",
  null
  
)

export default component.exports